export const appbar = {
  header: '固定資產管理系統',
}
